import './Afereclassification.scss';
import { Accordion, AttachmentCommonUpload, Card, Col, Datepicker, InputField, Label, OutlineButton, PopupDialogbox, PrimaryButton, RadioContainer, ReactSelectBox, Tooltip } from 'client/CommonComponents'; // Assuming this is the correct path for the Accordion component
import deleteicon from "../../../../../../assets/images/Delete New.svg"; // Ensure the correct path for the image
import InputContainer from 'client/CommonComponents/Input';
import { CONSTANTS } from 'client/utils/constants';
import TagInput from "client/CommonComponents/Tags";
import permissions, { isAuthorized } from 'client/utils/Permissions';
const { ATTACHMENTS_TOOLTIP_CONTENT } = CONSTANTS;

const Afereclassification = (props?: any) => {

    const {
        selectedAfeType,
        onInvoicedAmountchange,
        onAddress1change,
        onInvoicedAmountBlur,
        onAddress2change,
        onCitychange,
        onStateChange,
        onZipChange,
        onJeDescriptionChange,
        onRepairRequiredChange,
        onEfficiencyIncreasedChange,
        onLifeExtendedOneYearChange,
        onRepairOver1500Change,
        afeAssetDetailData,
        afeBranchAddressDetail,
        onUploadClick,
        onRemoveClick,
        error,
        setError,
        list,
        setList,
        docList,
        onLeaseIdchange,
        handleLeaseExpirationDateChange,
        onClickOfSaveOrSubmit,
        onAssetNumberChange,
        onClickCancel,
        Popupcontent,
        onGetAssetInfoClick,
        handleKeyPress,
        onClickDeleteicon,
        afeOrderByIdData,
        isEditOrder,
        onClickOfReset,
        cancelRequestOnClick,
        onClickOfRevertChanges,
        cancelPopContent,
        popupCancelPrimarybtnOnclick,
        addressListLoad,
        addressSearchText,
        addressDropDownListTemp,
        filterLocationOptionAddress1
    } = props;

    const radiooptions = [
        { key: 'Yes', text: 'Yes' },
        { key: 'No', text: 'No' },
    ];

    const disabledRadioOptions = [
        { key: 'Yes', text: 'Yes', disabled: true },
        { key: 'No', text: 'No', disabled: true },
    ];

    const expandedItems = () => {
        return [
            {
                headerText: (
                    <>
                        <div className="pull-left">
                            <p className="accordion-heading not-added-to-cart mt-2">ITEM # : 1</p>
                        </div>
                        {/* <div className="right-heading-disposition">
                            <img src={deleteicon} onClick={onClickDeleteicon} alt="Delete Order" className="me-2 pull-right" />
                        </div> */}
                    </>
                ),
                content: (
                    <>
                        <div className="p-3 pb-0 afe_accordion">
                            <Col xl={12}>
                                <div className='row'>
                                    <Col xl={10} lg={12} md={12}>
                                        <p className='note-text'>
                                            For the Request to be completed in the current month ,
                                            the AFE must be fully approved and in the FAA's queue no later than the end of Business Day +1.
                                            Anything after that will be reviewed in the following month.
                                        </p>
                                    </Col>
                                    <Col xl={2} lg={12} md={12} className="mt-3 mt-xl-0 mt-lg-0 mt-md-0 ">
                                        <div className="pull-right afe_attachment">
                                            <AttachmentCommonUpload
                                                link={true}
                                                list={list}
                                                uploadedList={docList}
                                                setList={setList}
                                                multiple={true}
                                                uploadBtnClick={onUploadClick}
                                                error={error}
                                                setError={setError}
                                                maxSize={5}
                                                onRemove={onRemoveClick}
                                                isAttachmentsRequired={true}
                                                tooltipConent={ATTACHMENTS_TOOLTIP_CONTENT}
                                                iAttachmentEditable={true}
                                                isDownloadable={false}
                                                isRequiredError={afeAssetDetailData?.uploadAttachmentsError?.length > 0}
                                                disabled={!isAuthorized(permissions.CreateUpdateAfeRequest)}
                                             data-attribute="Afereclassification_Default_AttachmentCommonUpload" />
                                        </div>
                                    </Col>

                                </div>
                            </Col>

                            <Col xl={12} className="pt-4">
                                <div className='row'>
                                    <Col xl={6}>
                                        <>
                                            <div className='row pt-3'>
                                                {(selectedAfeType.label == CONSTANTS.BUILDING_IMPROVEMENTS || selectedAfeType.label == CONSTANTS.FLEET_EQUIPMENT) ?
                                                    <div className='col-xl-5 col-md-12'>
                                                        <Label required data-attribute="Afereclassification_Default_Label">Parent Asset #
                                                            <span>
                                                                <Tooltip content={selectedAfeType.label == CONSTANTS.FLEET_EQUIPMENT ?
                                                                 "If you need assistance locating the parent asset # please refer to the branch Active Asset Listing." :
                                                                 "If you need assistance locating the parent asset # for company-owned building improvements, please contact the Real Estate Dept."}
                                                                 data-attribute="Afereclassification_Default_Tooltip">
                                                                    <span className="fa fa-info-circle attachment-info"></span>
                                                                </Tooltip>
                                                            </span>
                                                        </Label>
                                                        <div className='orderexist_afe'>
                                                            <InputContainer
                                                                onKeyPress={handleKeyPress}
                                                                multiline={false}
                                                                resizable={false}
                                                                className={afeAssetDetailData?.assetNumberError?.length > 0 ? "controlValidation" : ''}
                                                                onChange={(e?: any, item?: any) => onAssetNumberChange(e, item)}
                                                                value={afeAssetDetailData?.assetNumber ?? ''}
                                                            />
                                                            <PrimaryButton text='Get Asset Info' onClick={onGetAssetInfoClick}  data-attribute="Afereclassification_Default_Button" />
                                                        </div>
                                                        {afeAssetDetailData?.assetNumberError?.length > 0 && <span className="validMessage">{afeAssetDetailData?.assetNumberError}</span>}
                                                    </div>
                                                    : null}

                                                <Col xl={6} md={6} sm={12}>
                                                    <div>
                                                        <div className='Doclabel_tooltip'>
                                                            <Label required data-attribute="Afereclassification_Default_Label_2">Quoted Amount
                                                                <span className='ms-1'>
                                                                    <Tooltip content={"Must agree to the attached Invoice(s).  If detailed workorder, please summarize by task completed. i.e., Painting, Flooring, Electrical, etc.."} data-attribute="Afereclassification_Default_Tooltip_2">
                                                                        <span className="fa fa-info-circle attachment-info"></span>
                                                                    </Tooltip>
                                                                </span>
                                                            </Label>
                                                        </div>

                                                        <div className="input_id">
                                                            <InputContainer
                                                                placeholder='0.00'
                                                                onChange={(e?: any) => onInvoicedAmountchange(e)}
                                                                value={afeAssetDetailData?.invoicedAmount ?? ''}
                                                                onBlur={(e?: any) => onInvoicedAmountBlur(e)}
                                                                multiline={false}
                                                                prefix="$"
                                                                resizable={false}
                                                                className={afeAssetDetailData?.invoicedAmountError?.length > 0 ? "controlValidation invoiced_amt" : 'invoiced_amt'} />
                                                        </div>
                                                        {afeAssetDetailData?.invoicedAmountError?.length > 0 && <span className="validMessage">{afeAssetDetailData?.invoicedAmountError}</span>}

                                                    </div>
                                                </Col>
                                            </div>
                                            {(selectedAfeType.label == CONSTANTS.BUILDING_IMPROVEMENTS || selectedAfeType.label == CONSTANTS.FLEET_EQUIPMENT) ?
                                                <div className='row pt-3'>
                                                    <div className='col-12'>
                                                        <Label  data-attribute="Afereclassification_Default_Label_3">Asset Information</Label>
                                                        <div className="afe_assetinfo_row">
                                                            <Col xl={12}>
                                                                <div className='row'>
                                                                    <Col xl={4} md={6}>
                                                                        <Label data-attribute="Afereclassification_Default_Label_4">Unit #</Label>
                                                                        <span className='value'>{afeAssetDetailData?.unitNumber ?? '-'}</span>
                                                                    </Col>
                                                                    <Col xl={4} md={6}>
                                                                        <Label data-attribute="Afereclassification_Default_Label_5">Year</Label>
                                                                        <span className='value'>{afeAssetDetailData?.year ?? '-'}</span>
                                                                    </Col>
                                                                    <Col xl={4} md={6} className="pt-xl-0 pt-lg-0 pt-md-2 pt-0">
                                                                        <Label data-attribute="Afereclassification_Default_Label_6">Equipment Status</Label>
                                                                        <span className='value'>{afeAssetDetailData?.eqStatus ?? '-'}</span>
                                                                    </Col>
                                                                    <Col xl={4} md={6} className="pt-2">
                                                                        <Label data-attribute="Afereclassification_Default_Label_7">Equipment Class</Label>
                                                                        <span className='value'>{afeAssetDetailData?.eqClass ?? '-'}</span>
                                                                    </Col>
                                                                    <Col xl={4} md={6} className="pt-2">
                                                                        <Label data-attribute="Afereclassification_Default_Label_8">VIN / Serial #</Label>
                                                                        <span className='value'>{afeAssetDetailData?.vinSerialNumber ?? '-'}</span>
                                                                    </Col>
                                                                    <Col xl={4} md={6} className="pt-2">
                                                                        <Label data-attribute="Afereclassification_Default_Label_9">License #</Label>
                                                                        <span className='value'>{afeAssetDetailData?.licenseNumber ?? '-'}</span>
                                                                    </Col>
                                                                    <Col xl={4} md={6} className="pt-2">
                                                                        <Label data-attribute="Afereclassification_Default_Label_10">Net Booked Value</Label>
                                                                        <span className='value'>$ {afeAssetDetailData?.netBookedValue ?? '0.00'}</span>
                                                                    </Col>
                                                                    <Col xl={4} md={6} className="pt-2">
                                                                        <Label data-attribute="Afereclassification_Default_Label_11">Cost</Label>
                                                                        <span className='value'>$ {afeAssetDetailData?.cost ?? '0.00'}</span>
                                                                    </Col>
                                                                    <Col xl={12} md={12} className="pt-2">
                                                                        <Label data-attribute="Afereclassification_Default_Label_12">Description</Label>
                                                                        <span className='value'>{afeAssetDetailData?.description ?? '-'}</span>
                                                                    </Col>
                                                                </div>
                                                            </Col>
                                                        </div>
                                                    </div>
                                                </div>
                                                : null}
                                        </>

                                        <div className='row'>
                                            {(selectedAfeType.label == CONSTANTS.LEASEHOLD_IMPROVEMENTS) &&
                                                <Col xl={6} md={6} sm={12} className="pt-3">
                                                    <div className='Doclabel_tooltip lookuplinkWrapper'>
                                                        <Label required data-attribute="Afereclassification_Default_Label_13">Lease ID #
                                                            <span>
                                                                <Tooltip content={"Please use the 'LeaseID Lookup' link to access file with Lease IDs, addesses and expiration dates."} data-attribute="Afereclassification_Default_Tooltip_3">
                                                                    <span className="fa fa-info-circle attachment-info ms-1"></span>
                                                                </Tooltip>
                                                            </span>
                                                        </Label>
                                                        <a
                                                            href={process.env.REACT_APP_LEASEID_LOOKUP_URL}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="leaseid-lookup-link"
                                                        >
                                                            LeaseID Lookup
                                                        </a>
                                                    </div>
                                                    <div className='leaseinput_tooltip'>
                                                        <div className="input_id">
                                                            <InputContainer
                                                                placeholder='Enter Lease ID (e.g., A#1234)'
                                                                onChange={(e?: any) => onLeaseIdchange(e)}
                                                                value={afeAssetDetailData?.leaseId ?? ''}
                                                                multiline={false}
                                                                resizable={false}
                                                                className={afeAssetDetailData?.leaseIdError?.length > 0 ? "controlValidation invoiced_amt" : 'invoiced_amt'}
                                                            />
                                                        </div>
                                                    </div>
                                                     {afeAssetDetailData?.leaseIdError?.length > 0 && <span className="validMessage">{afeAssetDetailData?.leaseIdError}</span>}
                                                </Col>
                                            }
                                        </div>

                                        <div className='row'>
                                            {(selectedAfeType.label == CONSTANTS.LEASEHOLD_IMPROVEMENTS) &&
                                                <Col xl={6} md={6} sm={12} className="pt-3">
                                                    <div>
                                                        <div className='Doclabel_tooltip'>
                                                            <Label required data-attribute="Afereclassification_Default_Label_14">Expected Lease Expiration Date - Include Extension or Renewal Options
                                                                <span>
                                                                    <Tooltip
                                                                        content={"Please use the ‘Lease ID Lookup’ link to access the file with leases and expiration dates. If the branch is reasonably certain it will exercise any renewal option(s), include expiration date for existing renewal option(s)."}
                                                                     data-attribute="Afereclassification_Default_Tooltip_4">
                                                                        <span className="fa fa-info-circle attachment-info"></span>
                                                                    </Tooltip>
                                                                </span>
                                                            </Label>
                                                        </div>

                                                        <div className='leaseinput_tooltip'>
                                                            <div className="input_id">
                                                                <Datepicker
                                                                    placeholder="MM/DD/YYYY"
                                                                    allowTextInput={true}
                                                                    value={afeAssetDetailData?.leaseExpirationDate ? new Date(afeAssetDetailData?.leaseExpirationDate) : null}
                                                                    onChangeDate={(date: any) => handleLeaseExpirationDateChange(date)}
                                                                    minDate={new Date()}
                                                                 data-attribute="Afereclassification_Default_Datepicker" />
                                                            </div>
                                                        </div>
                                                        {afeAssetDetailData?.leaseExpirationDateError?.length > 0 && <span className="validMessage">{afeAssetDetailData?.leaseExpirationDateError}</span>}
                                                    </div>
                                                </Col>
                                            }
                                        </div>

                                        <div className='row pt-3'>
                                            <Col xl={12} md={12} sm={12} className="pt-2">
                                                <div>
                                                    <Label required data-attribute="Afereclassification_Default_Label_15">Description and Justification of Expenditure</Label>
                                                    <InputContainer
                                                        onChange={(e?: any) => onJeDescriptionChange(e)}
                                                        value={afeAssetDetailData?.jeDescription ?? ''}
                                                        multiline={true}
                                                        resizable={false}
                                                        className={afeAssetDetailData?.jeDescriptionError?.length > 0 ? "controlValidation justification_expenditure" : 'justification_expenditure'} />
                                                </div>
                                                {afeAssetDetailData?.jeDescriptionError?.length > 0 && <span className="validMessage">{afeAssetDetailData?.jeDescriptionError}</span>}
                                            </Col>
                                        </div>


                                    </Col>
                                    <Col xl={6}>
                                        <div className='row pt-3'>
                                            <div className="repair_radios">
                                                {selectedAfeType.label == CONSTANTS.FLEET_EQUIPMENT ?
                                                    <>
                                                        <Col xl={12}>
                                                            <div>
                                                                <Label required data-attribute="Afereclassification_Default_Label_16">Is this request for a repair of any kind?</Label>
                                                                <RadioContainer
                                                                    options={radiooptions}
                                                                    onChange={(e?: any, item?: any) => onRepairRequiredChange(e, item)}
                                                                    className='afe-radio-container'
                                                                    selectedKey={afeAssetDetailData?.isRepairRequest?.key || null}
                                                                 data-attribute="Afereclassification_Default_Radio" />
                                                            </div>
                                                        </Col>
                                                        <Col xl={12} className="pt-4">
                                                            <div>
                                                                <Label data-attribute="Afereclassification_Default_Label_17">Is the value of the repair over $1,500.00?</Label>
                                                                <RadioContainer
                                                                    options={afeAssetDetailData?.isRepairRequest?.key == 'Yes' ? radiooptions : disabledRadioOptions}
                                                                    className='afe-radio-container'
                                                                    onChange={(e?: any, item?: any) => onRepairOver1500Change(e, item)}
                                                                    selectedKey={afeAssetDetailData?.isRepairValueOver1500?.key || null}
                                                                 data-attribute="Afereclassification_Default_Radio_2" />
                                                            </div>
                                                        </Col>
                                                        <Col xl={12} className="pt-4">
                                                            <div>
                                                                <Label data-attribute="Afereclassification_Default_Label_18">Will the operating capacity or
                                                                    efficiency of the asset be substantially
                                                                    increased?</Label>
                                                                <RadioContainer
                                                                    options={afeAssetDetailData?.isRepairRequest?.key == 'Yes' ? radiooptions : disabledRadioOptions}
                                                                    className='afe-radio-container'
                                                                    onChange={(e?: any, item?: any) => onEfficiencyIncreasedChange(e, item)}
                                                                    selectedKey={afeAssetDetailData?.isEfficiencyIncreased?.key || null}
                                                                 data-attribute="Afereclassification_Default_Radio_3" />
                                                            </div>
                                                        </Col>
                                                        <Col xl={12} className="pt-4">
                                                            <div>
                                                                <Label data-attribute="Afereclassification_Default_Label_19">Will the life of the asset be extended
                                                                    ONE YEAR beyond the original useful
                                                                    life?</Label>
                                                                <RadioContainer
                                                                    options={afeAssetDetailData?.isRepairRequest?.key == 'Yes' ? radiooptions : disabledRadioOptions}
                                                                    className='afe-radio-container'
                                                                    onChange={(e?: any, item?: any) => onLifeExtendedOneYearChange(e, item)}
                                                                    selectedKey={afeAssetDetailData?.isLifeExtendedOneYear?.key || null}
                                                                 data-attribute="Afereclassification_Default_Radio_4" />
                                                            </div>
                                                        </Col>
                                                        {afeAssetDetailData?.repairRequestError?.length > 0 && <span className="validMessage">{afeAssetDetailData?.repairRequestError}</span>}
                                                    </>
                                                    : null}
                                            </div>

                                        </div>
                                    </Col>

                                    <div className='col-12 pt-3'>
                                        <div className='row'>
                                            <div>
                                                <Label className='pt-2 mb-0' data-attribute="Afereclassification_Default_Label_20">{selectedAfeType.label === CONSTANTS.FLEET_EQUIPMENT ? 'Branch Address Information' : 'Physical Address for Improvement'}</Label>
                                            </div>

                                            <Col xl={3} lg={6} md={6} className="pt-2">
                                                <div>
                                                    <Label required data-attribute="Afereclassification_Default_Label_21">Address 1</Label>
                                                    <div className="input_id">
                                                        {/* <InputContainer
                                                            multiline={false}
                                                            resizable={false}
                                                            placeholder='Enter Address 1'
                                                            className={afeBranchAddressDetail?.addLine1Error?.length > 0 ? "controlValidation address" : 'address'}
                                                            onChange={(e?: any) => onAddress1change(e)}
                                                            value={afeBranchAddressDetail?.addLine1 ?? ''}
                                                        /> */}
                                                        <ReactSelectBox
                                                            options={addressDropDownListTemp}
                                                            onChange={(e?: any) => onAddress1change(e)}
                                                            value={afeBranchAddressDetail?.addLine1?.length ? { label: afeBranchAddressDetail.addLine1, text: afeBranchAddressDetail.addLine1 } : ""}
                                                            placeholder="Search"
                                                            isSearchable={true}
                                                            isLoading={addressListLoad}
                                                            inputValue={addressSearchText}
                                                            noOptionsMessage={() => "Not Available"}
                                                            isClearable={true}
                                                            onInputChange={(value: any, action: any) => filterLocationOptionAddress1(value, action)}
                                                            className={afeBranchAddressDetail?.addLine1Error?.length > 0 ? "controlValidation address" : 'address'}
                                                         data-attribute="Afereclassification_Default_SearchSelectBox" />
                                                    </div>
                                                </div>
                                                {afeBranchAddressDetail?.addLine1Error?.length > 0 && <span className="validMessage">{afeBranchAddressDetail?.addLine1Error}</span>}
                                            </Col>

                                            <Col xl={3} lg={3} md={6} sm={12} className="pt-2">
                                                <div>
                                                    <Label data-attribute="Afereclassification_Default_Label_22">Address 2</Label>
                                                    <div className="input_id">
                                                        <InputContainer
                                                            multiline={false}
                                                            resizable={false}
                                                            onChange={(e?: any) => onAddress2change(e)}
                                                            value={afeBranchAddressDetail?.addLine2 ?? ''}
                                                            placeholder='Enter Address 2'
                                                            className={afeBranchAddressDetail?.addLine2Error?.length > 0 ? "controlValidation address" : 'address'} />
                                                    </div>
                                                </div>
                                                {afeBranchAddressDetail?.addLine2Error?.length > 0 && <span className="validMessage">{afeBranchAddressDetail?.addLine2Error}</span>}
                                            </Col>

                                            <Col xl={3} lg={3} md={6} sm={12} className="pt-2">
                                                <div>
                                                    <Label required data-attribute="Afereclassification_Default_Label_23">City</Label>
                                                    <div className="input_id">
                                                        <InputContainer
                                                            onChange={(e?: any) => onCitychange(e)}
                                                            value={afeBranchAddressDetail?.assetCity ?? ''}
                                                            multiline={false}
                                                            resizable={false}
                                                            placeholder='Enter City'
                                                            className={afeBranchAddressDetail?.assetCityError?.length > 0 ? "controlValidation address" : 'address'} />
                                                    </div>
                                                </div>
                                                {afeBranchAddressDetail?.assetCityError?.length > 0 && <span className="validMessage">{afeBranchAddressDetail?.assetCityError}</span>}
                                            </Col>

                                            <Col xl={3} lg={3} md={6} sm={12} className="pt-2">
                                                <div>
                                                    <Label required data-attribute="Afereclassification_Default_Label_24">State</Label>
                                                    <div className="input_id">
                                                        <InputContainer
                                                            onChange={(e?: any) => onStateChange(e)}
                                                            value={afeBranchAddressDetail?.assetState ?? ''}
                                                            multiline={false}
                                                            resizable={false}
                                                            placeholder='Enter State'
                                                            className={afeBranchAddressDetail?.assetStateError?.length > 0 ? "controlValidation address" : 'address'} />
                                                    </div>
                                                </div>
                                                {afeBranchAddressDetail?.assetStateError?.length > 0 && <span className="validMessage">{afeBranchAddressDetail?.assetStateError}</span>}
                                            </Col>

                                            <Col xl={3} md={6} sm={12} className="pt-2">
                                                <div>
                                                    <Label required data-attribute="Afereclassification_Default_Label_25">Zip Code</Label>
                                                    <div className="input_id">
                                                        <InputContainer
                                                            onChange={(e?: any) => onZipChange(e)}
                                                            value={afeBranchAddressDetail?.assetZip ?? ''}
                                                            multiline={false}
                                                            resizable={false}
                                                            placeholder='Enter Zipcode'
                                                            className={afeBranchAddressDetail?.addZipError?.length > 0 ? "controlValidation address" : 'address'} />
                                                    </div>
                                                </div>
                                                {afeBranchAddressDetail?.assetZipError?.length > 0 && <span className="validMessage">{afeBranchAddressDetail?.assetZipError}</span>}
                                            </Col>
                                        </div>
                                    </div>

                                    <Col xl={12} className="pt-4">
                                        <div className='pull-right'>
                                            {(!isEditOrder || afeOrderByIdData.orderStatusId == 2) && <OutlineButton text='Cancel' onClick={onClickCancel}  data-attribute="Afereclassification_Default_Button_2" />}
                                            {(!isEditOrder || afeOrderByIdData.orderStatusId == 2) && <OutlineButton text='Save' onClick={(e?: any) => onClickOfSaveOrSubmit(e, 'Save')} disabled = {!isAuthorized(permissions.CreateUpdateAfeRequest)}  data-attribute="Afereclassification_Default_Button_3" />}
                                            <PrimaryButton className={'meaSubmitBtn'} text='Submit' onClick={(e?: any) => onClickOfSaveOrSubmit(e, 'Submit')} disabled = {!isAuthorized(permissions.CreateUpdateAfeRequest)}  data-attribute="Afereclassification_Default_Button_4" />
                                            <PrimaryButton className={'meaSubmitBtn'} text='Reset' onClick={(e?: any) => onClickOfReset(e)} disabled = {!isAuthorized(permissions.CreateUpdateAfeRequest)} data-attribute="Afereclassification_Default_Button_5" />
                                            {
                                                (isEditOrder || afeOrderByIdData?.orderStatus?.includes('Pending Approval')) && <PrimaryButton className='ml-2 meaSubmitBtn' text='Revert Changes' disabled = {!isAuthorized(permissions.CreateUpdateAfeRequest)} onClick={() => { onClickOfRevertChanges() }}
                                                 data-attribute="Afereclassification_Default_Button_6" />
                                            }
                                            {
                                                (isEditOrder || afeOrderByIdData?.orderStatus?.includes('Pending Approval')) && <OutlineButton text='Cancel Request' onClick={() => { cancelRequestOnClick() }} disabled = {!isAuthorized(permissions.CreateUpdateAfeRequest)} data-attribute="Afereclassification_Default_Button_7" />
                                            }
                                        </div>
                                    </Col>
                                </div>
                            </Col>



                        </div>
                    </>
                ),
                uuid: "afeaccordion",
            },
        ];
    };

    return (
        <div className="mt-3">
            <Card data-attribute="Afereclassification_Default_Card">
                <Accordion
                    Items={expandedItems()}  // Ensure expandedItems is called here
                    preExpanded={["afeaccordion"]}  // Pass the expanded items based on uuid
                    allowZeroExpanded
                    className="custom-accordion afe_custom_accordion"
                 data-attribute="Afereclassification_Default_Accordion" />
            </Card>
            {Popupcontent.isDialogVisible ?
                <PopupDialogbox
                    hideDialog={!Popupcontent.isDialogVisible}
                    onDismiss={Popupcontent?.popupOutlinebtnOnclick}
                    Popupcontent={Popupcontent}
                    popupOutlinebtnOnclick={Popupcontent?.popupOutlinebtnOnclick}
                    popupPrimarybtnOnclick={(
                        item: any,
                        actionby: string,
                        value: any
                    ) => {
                        Popupcontent?.popupPrimarybtnOnclick(
                            item,
                            actionby,
                            value
                        );
                    }}
                 data-attribute="Afereclassification_Default_PopupDilalogBox" /> : ""}
            {cancelPopContent.isDialogVisible ?
                <PopupDialogbox
                    hideDialog={!cancelPopContent.isDialogVisible}
                    onDismiss={cancelPopContent?.popupOutlinebtnOnclick}
                    Popupcontent={cancelPopContent}
                    popupOutlinebtnOnclick={cancelPopContent?.popupOutlinebtnOnclick}
                    popupPrimarybtnOnclick={(
                        item: any,
                        actionby: string,
                        value: any
                    ) => {
                        popupCancelPrimarybtnOnclick(
                            item,
                            actionby,
                            value
                        );
                    }}
                 data-attribute="Afereclassification_Default_PopupDilalogBox_2" /> : ""}
        </div>
    );
};

export default Afereclassification;
